import { render, staticRenderFns } from "./ResourceGidePreneur.vue?vue&type=template&id=225a2614"
import script from "./ResourceGidePreneur.vue?vue&type=script&lang=js"
export * from "./ResourceGidePreneur.vue?vue&type=script&lang=js"
import style0 from "./ResourceGidePreneur.vue?vue&type=style&index=0&id=225a2614&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports